import { SegmentedButton } from '@smartgift/frontend-toolkit';
import styled, { css } from 'styled-components';

import { Notification } from '@hero/atoms';
import { constants } from '@hero/configs';

const Description = styled.p`
  color: var(--color-neutral-800);
  font-size: 14px;
  margin-bottom: 16px;
`;

const DigitalWrapperFirstContent = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin-bottom: 16px;
  padding: 12px 0 8px;
`;

const DigitalWrapperFirstContentSelect = styled.div`
  align-items: center;
  display: flex;
  gap: 8px;
  width: 350px;
`;

const DigitalWrapper = styled.div`
  position: relative;

  .tab-button {
    font-size: 14px;
    min-width: 200px;
  }

  ${constants?.products?.card?.width &&
  css`
    img {
      object-position: top left;
      transform: scale(2.5);
      transform-origin: top left;
    }
  `}

  ${SegmentedButton.S.SegmentedButtonContent} {
    margin-top: 0;
    padding-top: 0;
  }
`;

const ImagePreviewWrapper = styled.div`
  display: grid;
  gap: 8px;
  grid-template-columns: ${({ hasWraps }) => (hasWraps ? 'repeat(7, 1fr)' : 'repeat(5, 1fr)')};
  margin-bottom: 16px;
`;

const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 16px;
`;

const PreviewSectionWrapper = styled.div`
  margin-bottom: 16px;
  margin-top: 16px;

  ${Notification.S.NotificationBody} {
    p {
      display: inline;
      padding-top: 14px;

      button,
      b {
        margin-left: 4px;
      }
    }
  }
`;

export {
  Description,
  DigitalWrapper,
  DigitalWrapperFirstContent,
  DigitalWrapperFirstContentSelect,
  ImagePreviewWrapper,
  PreviewSectionWrapper,
  TitleWrapper
};
